import { filterName } from "../utils";

export const applyAppFilters = (entities, appliedFilters) => {
  let filteredEntities = [...entities];

  // App Using AI - toggle filter
  if (appliedFilters[filterName.APP_USING_AI] === true) {
    filteredEntities = filteredEntities.filter((entity) => {
      return entity.is_using_ai === true;
    });
  }

  entities.length = 0;
  for (let i = 0; i < filteredEntities.length; i++) {
    entities[i] = filteredEntities[i];
  }
};
